// extracted by mini-css-extract-plugin
export var infoItem = "_ue-2";
export var title = "_ue-0";
export var value = "_ue-1";